import { render } from "./SentEmailSucceeded.vue?vue&type=template&id=ecd658fc"
import script from "./SentEmailSucceeded.vue?vue&type=script&lang=js"
export * from "./SentEmailSucceeded.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__